import { Injectable } from '@angular/core';
import { Invoice } from 'src/app/shared/models';

@Injectable({
  providedIn: 'root'
})
export class HelperService {

  constructor() { }

  getInvoiceStatus(invoice: Invoice, currentDate: string): string {
    if (invoice.ship && invoice.ship.sailing_date < currentDate && invoice.ship.arrival_date > currentDate && !invoice.is_paid) {
      return "In Transit";
    }

    if (invoice.ship && invoice.ship.sailing_date < currentDate && invoice.ship.arrival_date < currentDate && !invoice.is_paid) {
      return "Arrived";
    }

    if ((!invoice.ship || (invoice.ship && invoice.ship.sailing_date < currentDate)) && !invoice.is_paid) {
      return "In Japan";
    }

    if (invoice.ship && invoice.ship.sailing_date < currentDate && invoice.ship.arrival_date < currentDate && invoice.is_paid) {
      return "Cleared";
    }



    return "No Status";
  }

  getAge(invoice: Invoice,currentDate:string): string {

    let age: any = 0;

    if (invoice.ship && invoice.ship.sailing_date < currentDate && invoice.ship.arrival_date > currentDate) {
      age = invoice.ship && invoice.ship.arrival_date ? this.getDays(invoice.ship.arrival_date, currentDate) : 0; // In Transit
    }
    if (!invoice.ship || (invoice.ship && invoice.ship.sailing_date < currentDate)) {
      age = invoice.vehicle?.yard_date ? this.getDays(invoice.vehicle?.yard_date, currentDate) : 0; // In Japan -> No Color
    }

    if (invoice.ship && invoice.ship.sailing_date < currentDate && invoice.ship.arrival_date < currentDate && invoice.is_paid) {
      age = 0;
    }

    if (invoice.ship && invoice.ship.sailing_date < currentDate && invoice.ship.arrival_date < currentDate && !invoice.is_paid) {
      age = invoice.ship && invoice.ship.arrival_date ? this.getDays(invoice.ship.arrival_date, currentDate) : 0;  // Arrived -> Light orange (warning)
    }

    return `${age} days`; // No Status -> No Color
  }

  getDays(dateOne: string, dateTwo: string) {
    const date1: any = new Date(dateOne);
    const date2: any = new Date(dateTwo);

    const diffTime: any = Math.abs(date2 - date1); // difference in milliseconds
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24)); // convert ms to days

    return diffDays;
  }
}
